/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_Try_Free_Free_VerInputs */

const en_btn_try_free_free_ver = /** @type {(inputs: Btn_Try_Free_Free_VerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try for $0`)
};

const ar_btn_try_free_free_ver = /** @type {(inputs: Btn_Try_Free_Free_VerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جرّب مقابل 0 دولار`)
};

const de_btn_try_free_free_ver = /** @type {(inputs: Btn_Try_Free_Free_VerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für 0 € testen`)
};

const es_btn_try_free_free_ver = /** @type {(inputs: Btn_Try_Free_Free_VerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pruébalo por 0 $`)
};

const fr_btn_try_free_free_ver = /** @type {(inputs: Btn_Try_Free_Free_VerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essayer pour 0€`)
};

const it_btn_try_free_free_ver = /** @type {(inputs: Btn_Try_Free_Free_VerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prova per 0€`)
};

const ja_btn_try_free_free_ver = /** @type {(inputs: Btn_Try_Free_Free_VerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$0で試す`)
};

const ko_btn_try_free_free_ver = /** @type {(inputs: Btn_Try_Free_Free_VerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`무료 체험하기`)
};

const pt_br_btn_try_free_free_ver = /** @type {(inputs: Btn_Try_Free_Free_VerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experimente por $0`)
};

const ru_btn_try_free_free_ver = /** @type {(inputs: Btn_Try_Free_Free_VerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Попробовать за 0 $`)
};

const th_btn_try_free_free_ver = /** @type {(inputs: Btn_Try_Free_Free_VerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทดลองใช้ฟรี`)
};

const tr_btn_try_free_free_ver = /** @type {(inputs: Btn_Try_Free_Free_VerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ücretsiz dene`)
};

const zh_cn_btn_try_free_free_ver = /** @type {(inputs: Btn_Try_Free_Free_VerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0 元试用`)
};

const zh_tw_btn_try_free_free_ver = /** @type {(inputs: Btn_Try_Free_Free_VerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0 元試用`)
};

/**
* | output |
* | --- |
* | "Try for $0" |
*
* @param {Btn_Try_Free_Free_VerInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const btn_try_free_free_ver = /** @type {((inputs?: Btn_Try_Free_Free_VerInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_Try_Free_Free_VerInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_btn_try_free_free_ver(inputs)
	if (locale === "ar") return ar_btn_try_free_free_ver(inputs)
	if (locale === "de") return de_btn_try_free_free_ver(inputs)
	if (locale === "es") return es_btn_try_free_free_ver(inputs)
	if (locale === "fr") return fr_btn_try_free_free_ver(inputs)
	if (locale === "it") return it_btn_try_free_free_ver(inputs)
	if (locale === "ja") return ja_btn_try_free_free_ver(inputs)
	if (locale === "ko") return ko_btn_try_free_free_ver(inputs)
	if (locale === "pt_br") return pt_br_btn_try_free_free_ver(inputs)
	if (locale === "ru") return ru_btn_try_free_free_ver(inputs)
	if (locale === "th") return th_btn_try_free_free_ver(inputs)
	if (locale === "tr") return tr_btn_try_free_free_ver(inputs)
	if (locale === "zh_cn") return zh_cn_btn_try_free_free_ver(inputs)
	return zh_tw_btn_try_free_free_ver(inputs)
});